"use memo"

import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import ExchangeTaskEntry from './ExchangeTaskEntry'

interface AgentExchangeProps {
  campaignId: string
  task: AutopilotTaskDto
}

const AgentExchange = ({ campaignId, task }: AgentExchangeProps) => (
  <ExchangeTaskEntry
    actionButtonId="completeAgentExchangeBtn"
    campaignId={campaignId}
    panelKey="AgentExchangePanel"
    task={task}
    title="Agent Exchange"
  />
)

export default AgentExchange
